import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { addLocale } from 'ttag';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { PART_SEARCH_URL } from 'constants.js';
import store from './store/createStore.js';
import createServiceWorker from './sw/createSw.js';
import ELVSearchRouter from './routing/routers/elvsearch.js';
import MainRouter from './routing/routers/main.js';
import { getLocale, setLocale } from './utils.js';

addLocale('fi', require('./i18n/fi.po.json'));
addLocale('en', require('./i18n/en.po.json'));
addLocale('se', require('./i18n/se.po.json'));

const locale = getLocale();
setLocale(locale.slice(0, 2), true);

createServiceWorker(store);

polyfillCountryFlagEmojis();

const App = () => (
    <Provider store={store}>
        {window.location.hostname === PART_SEARCH_URL
            ? <ELVSearchRouter />
            : <MainRouter />}
    </Provider>
);

const rootElement = document.getElementById('root');
if(rootElement.hasChildNodes()) hydrate(<App />, rootElement);
else render(<App />, rootElement);

export { App };
